import { createActions, handleActions } from 'redux-actions';
import deepmerge from 'deepmerge';
import apiCall from '../api';

const defaultState = {
  data: {},
  modified: false,
  loading: true
};
const _actions = createActions({
  userProfile: {
    load: userId => async (dispatch, getState) => {
      dispatch(actions.setLoading(true));

      const result = await apiCall('/users/profile', {
        method: 'GET',
        args: { id: userId }
      });
      if (result.success) {
        dispatch(actions.setData(result.payload));
      }
      dispatch(actions.setLoading(false));
    },
    loadSwipes: payload => async (dispatch, getState) => {
      const userId = getState().userProfile.data._id;
      const result = await apiCall('/users/swipes', {
        method: 'GET',
        args: { id: userId }
      });

      console.log('swipes', result);
      dispatch(actions.loadSwipesDone(result.payload));
    },
    loadSwipesDone: payload => payload,
    loadMatches: payload => async (dispatch, getState) => {
      const userId = getState().userProfile.data._id;
      const result = await apiCall('/users/matches', {
        method: 'GET',
        args: { id: userId }
      });

      console.log('matches', result);
      dispatch(actions.loadMatchesDone(result.payload));
    },
    loadMatchesDone: payload => payload,
    loadTokens: payload => async (dispatch, getState) => {
      const userId = getState().userProfile.data._id;
      const result = await apiCall('/users/tokens', {
        method: 'GET',
        args: { id: userId }
      });

      dispatch(actions.loadTokensDone(result.payload));
    },
    loadTokensDone: payload => payload,

    setLoading: payload => payload,
    setData: payload => payload,
    updateData: payload => payload,
    saveData: payload => async (dispatch, getState) => {
      const data = getState().userProfile.data;
      const result = await apiCall('/users/update', {
        method: 'POST',
        args: {
          id: data._id,
          data: data
        }
      });
      dispatch(actions.saveDataDone(!result.success));
    },
    saveDataDone: payload => payload,
    updateUserStatus: payload => async (dispatch, getState) => {
      const data = getState().userProfile.data;
      let endpoint;
      if (payload === 'blocked') {
        endpoint = 'block';
      } else if (payload === 'deleted') {
        endpoint = 'delete';
      } else if (payload === 'active') {
        endpoint = 'restore';
      } else {
        return;
      }

      await apiCall('/users/' + endpoint, {
        method: 'POST',
        args: {
          id: data._id
        }
      });
      dispatch(actions.load(data._id));
    }
  }
});
const actions = _actions.userProfile;

const setLoading = (state, action) => {
  return Object.assign({}, state, { loading: action.payload });
};

const setData = (state, action) => {
  return Object.assign({}, state, { data: action.payload, modified: false });
};
const updateData = (state, action) => {
  return deepmerge(state, { data: { ...action.payload }, modified: true });
};

const loadSwipesDone = (state, action) => {
  return deepmerge(state, { data: { swipes: action.payload } });
};
const loadMatchesDone = (state, action) => {
  return deepmerge(state, { data: { matches: action.payload } });
};
const loadTokensDone = (state, action) => {
  return deepmerge(state, { data: { tokens: action.payload } });
};
const saveDataDone = (state, action) => {
  return deepmerge(state, { modified: action.payload });
};

const reducer = handleActions(
  {
    [actions.setLoading]: setLoading,
    [actions.setData]: setData,
    [actions.updateData]: updateData,
    [actions.loadSwipesDone]: loadSwipesDone,
    [actions.loadMatchesDone]: loadMatchesDone,
    [actions.saveDataDone]: saveDataDone,
    [actions.loadTokensDone]: loadTokensDone
  },
  defaultState
);

export { actions, reducer };
